import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-star-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M7.014 1.074c.365-.877 1.607-.877 1.972 0L10.62 5l4.238.34c.947.075 1.332 1.257.61 1.876l-3.23 2.766.987 4.135c.22.925-.785 1.655-1.596 1.16L8 13.06l-3.628 2.216c-.811.495-1.817-.235-1.596-1.16l.986-4.135L.533 7.216c-.722-.619-.337-1.8.61-1.877L5.38 5l1.633-3.925zm1.08 11.929zM8 1.957L6.492 5.582c-.153.37-.501.623-.9.655l-3.914.314L4.66 9.105c.304.26.437.669.344 1.059l-.911 3.818 3.35-2.046a1.068 1.068 0 011.114 0l3.35 2.046-.91-3.818c-.094-.39.04-.799.343-1.06l2.982-2.553-3.913-.314a1.068 1.068 0 01-.901-.655L8 1.957z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const StarIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
StarIcon.displayName = 'StarIcon';